module.exports = __webpack_public_path__ + "img/WAPPR.04b4cffd.svg";